// Serviço de Tutoriais
import apiClient from './client';
import { endpoints } from './endpoints';
import type { Tutorial } from '@/types';

export const tutorialService = {
  async list(filters: Record<string, unknown> = {}): Promise<Tutorial[] | unknown> {
    const response = await apiClient.get(endpoints.tutorials.list, { params: filters });
    return response.data;
  },
  async getBySlug(slug: string): Promise<Tutorial | unknown> {
    const response = await apiClient.get(endpoints.tutorials.get(slug));
    return response.data;
  },
  async getById(id: string): Promise<Tutorial | unknown> {
    const response = await apiClient.get(endpoints.tutorials.get(id));
    return response.data;
  },
  async create(tutorialData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.post(endpoints.tutorials.create, tutorialData);
    return response.data;
  },
  async update(id: string, tutorialData: Record<string, unknown>): Promise<unknown> {
    const response = await apiClient.put(endpoints.tutorials.update(id), tutorialData);
    return response.data;
  },
  async delete(id: string): Promise<unknown> {
    const response = await apiClient.delete(endpoints.tutorials.delete(id));
    return response.data;
  },
  async search(query: string, options: Record<string, unknown> = {}): Promise<unknown> {
    const response = await apiClient.get(endpoints.tutorials.search, {
      params: { q: query, ...options },
    });
    return response.data;
  },
  async getByCategory(categorySlug: string): Promise<unknown> {
    const response = await apiClient.get(endpoints.tutorials.byCategory(categorySlug));
    return response.data;
  },
  async publish(id: string): Promise<unknown> {
    const response = await apiClient.post(endpoints.tutorials.publish(id));
    return response.data;
  },
  async unpublish(id: string): Promise<unknown> {
    const response = await apiClient.post(endpoints.tutorials.unpublish(id));
    return response.data;
  },
};
